<template>
  <div class="audio-viewer_container">
    <div v-if="audioUrl">
      <audio :src="audioUrl" controls preload="metadata" autoplay></audio>
    </div>
    <p v-else>No audio loaded...</p>
  </div>
</template>

<script setup>
import { ref, watchEffect } from "vue";
import { useStore } from "vuex";

const props = defineProps({
  documentName: String,
});

const store = useStore();
const audioUrl = ref(null);

const getAudioBlob = (fileBytes, fileName) => {
  console.log("Creating audio blob:", { fileBytes, fileName });

  if (!fileBytes) {
    console.warn("❌ No file bytes provided.");
    return null;
  }

  // Detect mime type from extension
  let ext = fileName?.split(".").pop()?.toLowerCase();
  let mimeType = {
    wav: "audio/wav",
    mp3: "audio/mpeg",
    m4a: "audio/mp4",
    aif: "audio/aiff",
    aiff: "audio/aiff",
  }[ext] || "audio/mpeg";

  console.log("Detected MIME type:", mimeType);

  if (fileBytes instanceof Blob) {
    console.log("✔ fileBytes is already a Blob");
    return fileBytes;
  }

  if (fileBytes instanceof ArrayBuffer) {
    console.log("✔ fileBytes is ArrayBuffer");
    return new Blob([fileBytes], { type: mimeType });
  }

  if (fileBytes instanceof Uint8Array) {
    console.log("✔ fileBytes is Uint8Array");
    return new Blob([fileBytes], { type: mimeType });
  }

  // Base64 fallback
  if (typeof fileBytes === "string") {
    console.log("✔ fileBytes is Base64 string");
    const byteCharacters = atob(fileBytes);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    return new Blob([new Uint8Array(byteNumbers)], { type: mimeType });
  }

  console.warn("❌ Unknown fileBytes type:", typeof fileBytes);
  return null;
};

// Watch for changes
watchEffect(() => {
  const doc = store.getters.getDocumentById(props.documentName);
  console.log("Loaded document from Vuex:", doc);

  if (!doc) {
    console.warn("❌ No document found for:", props.documentName);
    audioUrl.value = null;
    return;
  }

  const blob = getAudioBlob(doc.FileBytes, doc.FileName);

  if (!blob) {
    console.error("❌ Failed to create Blob.");
    audioUrl.value = null;
    return;
  }

  // Create object URL
  if (audioUrl.value) URL.revokeObjectURL(audioUrl.value);
  audioUrl.value = URL.createObjectURL(blob);

  console.log("✔ Audio URL created:", audioUrl.value);
});
</script>
